/**
 * @generated SignedSource<<dfb3843f1d39aab778b4176cf2687df5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mention_AtlassianSearchPage_UserMention$data = {
  readonly allContributors: ReadonlyArray<{
    readonly email: string | null | undefined;
    readonly extendedProfile: {
      readonly jobTitle: string | null | undefined;
    } | null | undefined;
    readonly externalId: string;
    readonly name: string | null | undefined;
    readonly nickname: string | null | undefined;
    readonly picture: AGG$URL | null | undefined;
  }> | null | undefined;
  readonly entity: {
    readonly associatedWith?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entity: {
            readonly email?: string | null | undefined;
            readonly extendedProfile?: {
              readonly jobTitle: string | null | undefined;
            } | null | undefined;
            readonly externalId?: string;
            readonly name?: string | null | undefined;
            readonly nickname?: string | null | undefined;
            readonly picture?: AGG$URL | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly externalId?: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "mention_AtlassianSearchPage_UserMention";
};
export type mention_AtlassianSearchPage_UserMention$key = {
  readonly " $data"?: mention_AtlassianSearchPage_UserMention$data;
  readonly " $fragmentSpreads": FragmentRefs<"mention_AtlassianSearchPage_UserMention">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "externalId"
},
v1 = [
  (v0/*: any*/),
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "nickname"
  },
  {
    "kind": "ScalarField",
    "name": "email"
  },
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  {
    "concreteType": "ThirdPartyUserExtendedProfile",
    "kind": "LinkedField",
    "name": "extendedProfile",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "jobTitle"
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "mention_AtlassianSearchPage_UserMention",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "concreteType": "ExternalAssociationConnection",
              "kind": "LinkedField",
              "name": "associatedWith",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ExternalAssociationEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "ExternalAssociation",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "entity",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": (v1/*: any*/),
                              "type": "ThirdPartyUser"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        }
      ]
    },
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "allContributors",
      "plural": true,
      "selections": (v1/*: any*/)
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "0f985bc027ec0834f1a24c86f3852a30";

export default node;
